export default __webpack_public_path__ + "static/media/ProductExcel.2c3d88d1.xlsx";